export default __webpack_public_path__ + "static/media/status.8baa6d17.svg";